
export const getPermissionLevel = (path: string, role: string | undefined) => {

  // console.log(path);
  // console.log(role);

  // const paths: any = {

  //   'sales/solution': {
  //     ''
  //     'PARTNER_SALES_PERSON': '',
  //     'PARTNER_SOLUTION_ARCHITECT': '',
  //     'SALES_PERSON': '',
  //     '': '',
  //     '': '',
  //     '': '',
  //     '': ''
  //   }
  // };

  if (role && path === 'header/admin') {

    if ([ 'PARTNER_SALES_PERSON', 'PARTNER_SOLUTION_ARCHITECT', 'ACCENTURE_SALES_PERSON', 'ACCENTURE_SOLUTION_ARCHITECT', 'CLIENT' ].includes(role)) {
      return 'NONE';

    } else {
      return 'FULL';
    }

  } else if (role && path === 'header/engagements') {

    if ([ 'PARTNER_SALES_PERSON', 'PARTNER_SOLUTION_ARCHITECT', 'ACCENTURE_SALES_PERSON', 'ACCENTURE_SOLUTION_ARCHITECT', 'CLIENT' ].includes(role)) {
      return 'NONE';

    } else {
      return 'FULL';
    }

  } else if (role && path === 'sales/engagements') {

    if ([ 'PARTNER_SALES_PERSON', 'PARTNER_SOLUTION_ARCHITECT', 'ACCENTURE_SALES_PERSON', 'ACCENTURE_SOLUTION_ARCHITECT', 'CLIENT' ].includes(role)) {
      return 'NONE';

    } else {
      return 'OWNER_FULL';
    }

  } else if (role && path === 'sales/solutions') {

    if ([ 'PARTNER_SALES_PERSON', 'PARTNER_SOLUTION_ARCHITECT', 'ACCENTURE_SALES_PERSON', 'ACCENTURE_SOLUTION_ARCHITECT', 'CLIENT' ].includes(role)) {
      return 'OWNER_FULL';

    } else {
      return 'FULL';
    }

  } else if (role && path === 'sales/solution') {

    if ([ 'PARTNER_SALES_PERSON', 'PARTNER_SOLUTION_ARCHITECT', 'ACCENTURE_SALES_PERSON', 'ACCENTURE_SOLUTION_ARCHITECT', 'CLIENT' ].includes(role)) {
      return 'PARTNER_SUBMIT';

    } else {
      return 'FULL';
    }

  } else {
    return 'NONE';
  }
};
